import { useEffect, useRef, useState } from 'react';

const REVEAL_ROOT_MARGIN = '0px 0px -10% 0px';

export function useRevealOnScroll() {
    const ref = useRef(null);
    // Browsers without IntersectionObserver start revealed so content is never left hidden.
    const [isVisible, setIsVisible] = useState(() => typeof IntersectionObserver === 'undefined');

    useEffect(() => {
        const node = ref.current;
        if (!node || typeof IntersectionObserver === 'undefined') return undefined;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, { rootMargin: REVEAL_ROOT_MARGIN });

        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return { ref, isVisible };
}
